// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

body {
  background-color: #334559;
  color: white;
}

.container {
  position: relative;
  min-height: 100vh;
}

.wrapper {
  padding-bottom: 50px;
}

.navbar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #c1473a;
  border-bottom: 5px solid white;
  width: 100%;
}

.navbar-image {
  margin-left: 20px;
}

.navbar-image img {
  max-height: 200px;
}

.navbar-right {
  display: flex;
  align-items: baseline;
  font-size: 35px;
  font-weight: bold;
  margin-right: 10px;
}

.navbar-right a {
  color: white;
  text-decoration: none;
  margin-left: 10px;
  margin-right: 10px;
}

.navbar-right a:hover {
  color: #334559;
}

.book-now {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #334559;
  border: 5px solid white;
  border-radius: 20px;
  width: 250px;
  height: 80px;
  margin-left: 10px;
  margin-right: 10px;
}

.book-now a {
  color: white;
  text-decoration: none;
  font-size: 30px;
  font-weight: bold;
}

.book-now:hover {
  background-color: white;
  border: 5px solid #334559;
}

.book-now:hover a {
  color: #c1473a;
}

.home-page,
.about-page,
.services-page,
.gallery-page,
.not-found-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo img {
  max-height: 250px;
  margin-bottom: 20px;
}

.headline-section {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.slideshow {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75%;
  border: 5px solid white;
  margin: 0 auto;
  margin-bottom: 20px;
}

.slideshow img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.information-section,
.location-section,
.hours-section {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}

.location-section,
.hours-section {
  margin-left: 100px;
  margin-right: 100px;
}

.location-info,
.map,
.business-hours,
.hours-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 50%;
  padding: 20px;
}

.map img,
.business-hours img {
  max-height: 300px;
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 20px;
}

.map img {
  border: 5px solid #c1473a;
}

.about-page h1,
.services-page h1,
.gallery-page h1,
.not-found-page h1 {
  font-size: 60px;
  -webkit-text-stroke: 2.5px #c1473a;
  margin-bottom: 20px;
}

.about-section {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  height: -moz-fit-content;
  height: fit-content;
  margin-bottom: 100px;
}

.juan img {
  width: 400px;
  border-radius: 50%;
  border: 5px solid #c1473a;
  margin-left: 100px;
  margin-right: 50px;
}

.about-bio {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
  margin-left: 50px;
  margin-right: 100px;
}

.services-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: -moz-fit-content;
  height: fit-content;
  font-weight: bold;
  margin-bottom: 100px;
}

.services-section p {
  font-size: 20px;
}

.gallery-section,
.video-player-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 100px;
}

.gallery-photo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border: 5px solid white;
  border-radius: 10px;
  overflow: hidden;
}

.gallery-photo img {
  max-height: 300px;
}

.gallery-caption {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.invisible {
  color: #334559;
}

.video-player-section video {
  border: 5px solid white;
  border-radius: 10px;
  overflow: hidden;
  margin-left: 20px;
  margin-right: 20px;
}

.not-found-page img {
  max-height: 500px;
  border: 5px solid white;
  border-radius: 10px;
  overflow: hidden;
  margin: 20px;
}

.footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #c1473a;
  position: absolute;
  font-size: 14px;
  font-weight: bold;
  height: 50px;
  bottom: 0;
  width: 100%;
}

.copyright-section,
.web-designer-section {
  display: flex;
  align-items: center;
}

.web-designer-section a {
  color: white;
  text-decoration: none;
}

@media screen and (max-width: 768px) {
  .navbar {
    flex-direction: column;
    padding-bottom: 10px;
  }

  .navbar-image {
    margin-left: 0px;
    margin-bottom: 10px;
  }

  .navbar-image img {
    max-height: 150px;
  }

  .navbar-right {
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .navbar-right a {
    margin: 5px;
  }

  .navbar-right a:hover {
    display: white;
  }

  .book-now {
    border: 3px solid white;
    width: 170px;
    height: 50px;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .book-now a {
    font-size: 20px;
  }

  .book-now:hover {
    background-color: #334559;
    border: 3px solid white;
  }

  .book-now:hover a {
    color: white;
  }

  .logo img {
    width: 100%;
    margin-left: 20px;
    margin-right: 20px;
  }

  .information-section,
  .location-section,
  .hours-section,
  .about-section,
  .gallery-section,
  .gallery-photo,
  .video-player-section {
    flex-direction: column;
  }

  .location-section,
  .hours-section {
    margin-left: 0px;
    margin-right: 0px;
  }

  .location-info,
  .map,
  .business-hours,
  .hours-info {
    width: 100%;
    padding: 0px;
  }

  .location-info,
  .hours-info {
    margin-bottom: 20px;
  }

  .map img,
  .business-hours img,
  .juan img,
  .not-found-page img {
    width: 300px;
  }

  .map img,
  .juan img {
    border-radius: 50%;
    border: 5px solid #c1473a;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }

  .about-page h1,
  .services-page h1,
  .gallery-page h1,
  .not-found-page h1 {
    font-size: 40px;
    -webkit-text-stroke: 2px #c1473a;
  }

  .about-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .about-bio {
    text-align: center;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .gallery-section {
    margin-bottom: 15px;
  }

  .gallery-photo {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 15px;
  }

  .video-player-section div {
    margin-bottom: 10px;
  }

  .video-player-section video {
    margin-left: 0px;
    margin-right: 0px;
  }

  .not-found-page {
    text-align: center;
  }

  .footer {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAmB;EAAnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;;;;;IAOE,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;IAIE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;;;IAIE,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;;;IAIE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\nbody {\n  background-color: #334559;\n  color: white;\n}\n\n.container {\n  position: relative;\n  min-height: 100vh;\n}\n\n.wrapper {\n  padding-bottom: 50px;\n}\n\n.navbar {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  background-color: #c1473a;\n  border-bottom: 5px solid white;\n  width: 100%;\n}\n\n.navbar-image {\n  margin-left: 20px;\n}\n\n.navbar-image img {\n  max-height: 200px;\n}\n\n.navbar-right {\n  display: flex;\n  align-items: baseline;\n  font-size: 35px;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.navbar-right a {\n  color: white;\n  text-decoration: none;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.navbar-right a:hover {\n  color: #334559;\n}\n\n.book-now {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #334559;\n  border: 5px solid white;\n  border-radius: 20px;\n  width: 250px;\n  height: 80px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.book-now a {\n  color: white;\n  text-decoration: none;\n  font-size: 30px;\n  font-weight: bold;\n}\n\n.book-now:hover {\n  background-color: white;\n  border: 5px solid #334559;\n}\n\n.book-now:hover a {\n  color: #c1473a;\n}\n\n.home-page,\n.about-page,\n.services-page,\n.gallery-page,\n.not-found-page {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo img {\n  max-height: 250px;\n  margin-bottom: 20px;\n}\n\n.headline-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.slideshow {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 75%;\n  border: 5px solid white;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.slideshow img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.information-section,\n.location-section,\n.hours-section {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.location-section,\n.hours-section {\n  margin-left: 100px;\n  margin-right: 100px;\n}\n\n.location-info,\n.map,\n.business-hours,\n.hours-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 50%;\n  padding: 20px;\n}\n\n.map img,\n.business-hours img {\n  max-height: 300px;\n  border-radius: 50%;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.map img {\n  border: 5px solid #c1473a;\n}\n\n.about-page h1,\n.services-page h1,\n.gallery-page h1,\n.not-found-page h1 {\n  font-size: 60px;\n  -webkit-text-stroke: 2.5px #c1473a;\n  margin-bottom: 20px;\n}\n\n.about-section {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  height: fit-content;\n  margin-bottom: 100px;\n}\n\n.juan img {\n  width: 400px;\n  border-radius: 50%;\n  border: 5px solid #c1473a;\n  margin-left: 100px;\n  margin-right: 50px;\n}\n\n.about-bio {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  font-weight: bold;\n  margin-left: 50px;\n  margin-right: 100px;\n}\n\n.services-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: fit-content;\n  font-weight: bold;\n  margin-bottom: 100px;\n}\n\n.services-section p {\n  font-size: 20px;\n}\n\n.gallery-section,\n.video-player-section {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 100px;\n}\n\n.gallery-photo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  border: 5px solid white;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.gallery-photo img {\n  max-height: 300px;\n}\n\n.gallery-caption {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.invisible {\n  color: #334559;\n}\n\n.video-player-section video {\n  border: 5px solid white;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.not-found-page img {\n  max-height: 500px;\n  border: 5px solid white;\n  border-radius: 10px;\n  overflow: hidden;\n  margin: 20px;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  background-color: #c1473a;\n  position: absolute;\n  font-size: 14px;\n  font-weight: bold;\n  height: 50px;\n  bottom: 0;\n  width: 100%;\n}\n\n.copyright-section,\n.web-designer-section {\n  display: flex;\n  align-items: center;\n}\n\n.web-designer-section a {\n  color: white;\n  text-decoration: none;\n}\n\n@media screen and (max-width: 768px) {\n  .navbar {\n    flex-direction: column;\n    padding-bottom: 10px;\n  }\n\n  .navbar-image {\n    margin-left: 0px;\n    margin-bottom: 10px;\n  }\n\n  .navbar-image img {\n    max-height: 150px;\n  }\n\n  .navbar-right {\n    flex-direction: column;\n    align-items: center;\n    font-size: 20px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  .navbar-right a {\n    margin: 5px;\n  }\n\n  .navbar-right a:hover {\n    display: white;\n  }\n\n  .book-now {\n    border: 3px solid white;\n    width: 170px;\n    height: 50px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  .book-now a {\n    font-size: 20px;\n  }\n\n  .book-now:hover {\n    background-color: #334559;\n    border: 3px solid white;\n  }\n\n  .book-now:hover a {\n    color: white;\n  }\n\n  .logo img {\n    width: 100%;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .information-section,\n  .location-section,\n  .hours-section,\n  .about-section,\n  .gallery-section,\n  .gallery-photo,\n  .video-player-section {\n    flex-direction: column;\n  }\n\n  .location-section,\n  .hours-section {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  .location-info,\n  .map,\n  .business-hours,\n  .hours-info {\n    width: 100%;\n    padding: 0px;\n  }\n\n  .location-info,\n  .hours-info {\n    margin-bottom: 20px;\n  }\n\n  .map img,\n  .business-hours img,\n  .juan img,\n  .not-found-page img {\n    width: 300px;\n  }\n\n  .map img,\n  .juan img {\n    border-radius: 50%;\n    border: 5px solid #c1473a;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-bottom: 20px;\n  }\n\n  .about-page h1,\n  .services-page h1,\n  .gallery-page h1,\n  .not-found-page h1 {\n    font-size: 40px;\n    -webkit-text-stroke: 2px #c1473a;\n  }\n\n  .about-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n  }\n\n  .about-bio {\n    text-align: center;\n    font-size: 20px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .gallery-section {\n    margin-bottom: 15px;\n  }\n\n  .gallery-photo {\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-bottom: 15px;\n  }\n\n  .video-player-section div {\n    margin-bottom: 10px;\n  }\n\n  .video-player-section video {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  .not-found-page {\n    text-align: center;\n  }\n\n  .footer {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
